/*=========================================================================================
  File Name: module-supplier.js
  Description: Supplier Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-usersetup-state';
import mutations from './module-usersetup-mutations';
import actions from './module-usersetup-actions';
import getters from './module-usersetup-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
